import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getBudget,
  getProposals,
} from 'selectors/admin/work-orders/details/details';
import { getCurrentWorkOrder } from 'selectors/admin/work-orders/work-orders';
import { getCurrentUser } from 'selectors/authentication';
import { selectProposal } from 'actions/admin/work-orders/details/proposal-approval';
import { sortByAttribute } from 'services/utils/sort-util';
import { loadEmailProposalDataRequest } from 'actions/admin/work-orders/details/proposal';
import {
  loadEmailBudgetDataRequest,
  openApproveReviewModal,
} from 'actions/admin/work-orders/details/budget';
import { goToInvoice } from 'actions/admin/invoices/invoices';
import { ClientLinkButtons } from 'components/admin/work-orders/details/ClientLinkButtons';
import {
  selectChangeOrder,
  loadEmailChangeOrderDataRequest,
} from 'components/admin/work-orders/details/change-orders/store/actions';
import { getChangeOrders } from 'components/admin/work-orders/details/change-orders/store/selectors';

class ClientLinkButtonsContainer extends Component {
  handleViewBudget = () => {
    this.props
      .dispatch(
        loadEmailBudgetDataRequest(
          this.props.currentWorkOrder.number,
          this.props.currentWorkOrder.name,
          this.props.currentWorkOrder.building.location,
          this.props.currentWorkOrder.client.id
        )
      )
      .then((response) => {
        if (response.ok) {
          this.props.dispatch(openApproveReviewModal(this.props.budget));
        }
      });
  };

  handleViewInvoice = () => {
    this.props.dispatch(goToInvoice(this.props.currentWorkOrder.invoice.id));
  };

  handleViewQuote = () => {
    if (this.props.changeOrders.length === 0) {
      const sortedProposals = this.props.proposals.slice(); // copy slice before sorting
      sortByAttribute(sortedProposals, 'number', false);
      const lastProposal = sortedProposals.shift();

      this.props
        .dispatch(
          loadEmailProposalDataRequest(
            lastProposal.number,
            this.props.currentWorkOrder.number,
            this.props.currentWorkOrder.name,
            this.props.currentWorkOrder.building.location,
            this.props.currentWorkOrder.client.id,
            this.props.currentWorkOrder.client.company_name
          )
        )
        .then((response) => {
          if (response.ok) {
            this.props.dispatch(selectProposal(lastProposal));
          }
        });
    } else {
      const changeOrder = this.props.changeOrders[
        this.props.changeOrders.length - 1
      ];

      this.props
        .dispatch(
          loadEmailChangeOrderDataRequest(
            changeOrder.number,
            this.props.currentWorkOrder.number,
            this.props.currentWorkOrder.name,
            this.props.currentWorkOrder.building.location,
            this.props.currentWorkOrder.client.id
          )
        )
        .then((response) => {
          if (response.ok) {
            this.props.dispatch(selectChangeOrder(changeOrder));
          }
        });
    }
  };

  render() {
    return (
      <ClientLinkButtons
        budget={this.props.budget}
        proposals={this.props.proposals}
        user={this.props.currentUser}
        workOrder={this.props.currentWorkOrder}
        onBudgetClick={this.handleViewBudget}
        onInvoiceClick={this.handleViewInvoice}
        onQuoteClick={this.handleViewQuote}
      />
    );
  }
}

export default connect((state) => {
  return {
    budget: getBudget(state),
    currentUser: getCurrentUser(state),
    currentWorkOrder: getCurrentWorkOrder(state),
    proposals: getProposals(state),
    changeOrders: getChangeOrders(state),
  };
})(ClientLinkButtonsContainer);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/ClientLinkButtonsContainer.js